var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "creditLimitModal", role: "dialog", tabindex: "-1" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              !_vm.isRegisteredUser
                ? _c("unregistered-credit-limit")
                : _vm._e(),
              _vm._v(" "),
              _vm.isRegisteredUser && !_vm.isPremiumUser && !_vm.wasPremiumUser
                ? _c("registered-credit-limit")
                : _vm._e(),
              _vm._v(" "),
              _vm.isPremiumUser || _vm.wasPremiumUser
                ? _c("credit-exhausted-pro")
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn close-btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.close.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times mr-1" }),
                    _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Cancel")))]),
                  ]
                ),
                _vm._v(" "),
                !_vm.isRegisteredUser
                  ? _c(
                      "button",
                      {
                        staticClass: "btn submit-btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openSignUpModal.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("trans")("Sign Up"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isFreeUser
                  ? _c(
                      "button",
                      {
                        staticClass: "btn premium-btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUpgradeModal.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("trans")("Get Premium"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPremiumUser
                  ? _c(
                      "button",
                      {
                        staticClass: "btn premium-btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openBuyCreditsModal.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("trans")("Get more Credits"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }